module.exports = __webpack_public_path__ + "app-static/img/step2.397f8bd5.png";